<template>
<v-navigation-drawer :value="left" width="400" fixed temporary>
    <template v-slot:prepend class="pb-0 mb-0">
        <v-card tile class="pb-0 mb-0">
            
            <v-toolbar color="primary" >
                <v-flex cols="10" class="pb-0 mb-0 pl-1">
                        <!-- :items="items" @change="handleSelectTitular"-->
                        <v-autocomplete dense class="pb-0 mb-0 mt-4" item-text="descripcion" item-value="url" solo clearable label="Buscar en todas tus aplicaciones" hide-no-data />
                    </v-flex>
                <div class="flex-grow-1" />
                <v-btn fab :ripple="false" color="primary" depressed="" @click="closeSidebar">
                    <v-icon>mdi-apps</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>

    </template>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-title class="title">
                Aplicaciones
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-divider />
    <v-list nav>
        <v-list-item link exact="" to="/">
            <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>Mi Tablero UG</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item link to="aplicaciones">
            <v-list-item-icon>
                <v-icon>mdi-arrow-right-bold</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>Explorar servicios</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <!-- <v-list-group v-for="item in categorias" :key="item.id_Categoria" :prepend-icon="item.mui_Icono" no-action>
            <template v-slot:activator>
                <v-list-item-content>
                    <v-list-item-title>{{ item.dsc_Categoria }}</v-list-item-title>
                </v-list-item-content>
            </template>
        </v-list-group> -->
    </v-list>
</v-navigation-drawer>
</template>

<script>
import {
    mapActions
} from 'vuex'
export default {
    props: {
        left: {
            type: Boolean,
            required: true
        },
        closeSidebar: {
            type: Function,
            required: true
        },
        // servicios: {
        //     type: Array,
        //     required: true
        // },
        // categorias: {
        //     type: Array,
        //     required: true
        // },
        nue: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        },
        nombre: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions(['alterTablero']),
        go(url) {
            window.location = url
        },
        add(item) {
            this.alterTablero(item)
        }
    }
}
</script>
